module.exports = __webpack_public_path__ + "static/media/orange1.f5e188e6.png";